import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectFileDialogData, SelectFileDialogResult } from '../../core/utils/dialog.models';

@Component({
	selector: 'select-file-dialog',
	templateUrl: './select-file.component.html'
})
export class SelectFileDialogComponent implements OnInit {

	public title: string;
	public text: string;
	public okBtnText: string;
	public cancelBtnText: string;
	public accept: string;
	private file: File;

	public constructor(
		public dialogRef: MatDialogRef<SelectFileDialogComponent, SelectFileDialogResult>,
		@Inject(MAT_DIALOG_DATA) public data: SelectFileDialogData
	) {}

	public ngOnInit(): void {
		this.title = this.data.title;
		this.text = this.data.text;
		this.okBtnText = this.data.okBtnText;
		this.cancelBtnText = this.data.cancelBtnText;
		this.accept = this.data.accept;
	}

	public onFileInputChange(event: FileList): void {
		if (event.length) {
			this.file = event.item(0);
		} else {
			this.file = null;
		}
	}

	public onOkClick(): void {
		this.dialogRef.close({ file: this.file });
	}

	public onCancelClick(): void {
		this.dialogRef.close({ file: null });
	}

}
